import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Pagination } from '@lion-design/core';
import { I_CardsInfo_Common } from '@Redux/search/interfaces';
import { setAllSelected } from '@Redux/search/All/action';
import { setGroupSelected } from '@Redux/search/Group/action';
import { setHotelSelected } from '@Redux/search/Hotel/action';
import { setVocationSelected } from '@Redux/search/Vacation/action';
import { setTicketSelected } from '@Redux/search/Ticket/action';
import { setFlightSelected } from '@Redux/search/Flight/action';
import { RootState } from '@Redux/search/store';
import ResultNoData from '@components/SearchPage/ResultNoData';
import Skeletons from '@components/Common/Skeletons';
import Card from './Card';
import styles from '../styles.module.scss';

export interface I_Props {
    isLogin: boolean;
}

const Pc = ({ isLogin }: I_Props) => {
    const { FilterDataLoading, AllCardsInfo, TagList } = useSelector(
        (state: RootState) => state.search.reducer
    );
    const { GroupFilterSelected } = useSelector((state: RootState) => state.search.GroupReducer);
    const { HotelFilterSelected } = useSelector((state: RootState) => state.search.HotelReducer);
    const { TicketFilterSelected } = useSelector((state: RootState) => state.search.TicketReducer);
    const { VocationFilterSelected } = useSelector(
        (state: RootState) => state.search.VocationReducer
    );
    const { FlightFilterSelected } = useSelector(
        (state: RootState) => state.search.FlightReducer
    );
    const { AllFilterSelected } = useSelector((state: RootState) => state.search.AllReducer);

    const dispatch = useDispatch();

    let selectedStore = AllFilterSelected;
    let dispatchFn = setAllSelected;
    switch (TagList) {
        case 'grp':
            dispatchFn = setGroupSelected;
            selectedStore = GroupFilterSelected;
            break;
        case 'htl':
            dispatchFn = setHotelSelected;
            selectedStore = HotelFilterSelected;
            break;
        case 'vac':
            dispatchFn = setVocationSelected;
            selectedStore = VocationFilterSelected;
            break;
        case 'etk':
            dispatchFn = setTicketSelected;
            selectedStore = TicketFilterSelected;
            break;
        case 'flt':
            dispatchFn = setFlightSelected;
            selectedStore = FlightFilterSelected;
            break;
        default:
            break;
    }
    // 頁數改變時重新打API，觸發filterWithSort的useEffect
    const getCurPageList = (page: number) => {
        dispatch(dispatchFn({ Page: page }));
    };

    if (FilterDataLoading)
        // 每次更動篩選、頁數都是顯示skelton，與M版邏輯不同
        return (
            <>
                {Array.from(Array(10).keys()).map((index: number) => (
                    <Skeletons isMobile={false} key={'skeleton' + index} />
                ))}
            </>
        );

    if (AllCardsInfo.DataList?.length > 0)
        return (
            <>
                <ul>
                    {AllCardsInfo.DataList?.map((item: I_CardsInfo_Common, i: number) => (
                        <Card key={i} groupData={item} isLogin={isLogin} />
                    ))}
                </ul>
                <Pagination
                    className={styles.pageBar}
                    total={AllCardsInfo.Total > 1000 ? 1000 : AllCardsInfo.Total}
                    pageSize={10}
                    current={selectedStore.Page}
                    onChange={(page) => {
                        getCurPageList(page);
                        // 換頁後跳至最放上
                        window.scrollTo(0, 0);
                    }}
                />
            </>
        );

    return <ResultNoData />;
};

export default Pc;
